// extracted by mini-css-extract-plugin
module.exports = {"received-collaborator-nft-requests-list":"ReceivedCollaboratorNftUploadRequests_received-collaborator-nft-requests-list__3_ZJM"};